module.exports = __webpack_public_path__ + "static/media/meatza.ba2b0f6a.jpg";